module.exports = __webpack_public_path__ + "img/编组 2备份@2x.5c582c0a.png";